"use strict";

import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "render", "unmount"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as s from "react";

function o(_ref) {
  var e = _ref.children,
      _ref$render = _ref.render,
      t = _ref$render === void 0 ? "idle" : _ref$render,
      _ref$unmount = _ref.unmount,
      i = _ref$unmount === void 0 ? "never" : _ref$unmount,
      n = _objectWithoutProperties(_ref, _excluded);

  var _s$useState = s.useState(!n.hidden || t === "always"),
      _s$useState2 = _slicedToArray(_s$useState, 2),
      u = _s$useState2[0],
      c = _s$useState2[1];

  return s.useEffect(function () {
    !n.hidden || t === "always" ? c(!0) : t === "idle" ? ("requestIdleCallback" in window ? requestIdleCallback : setTimeout)(function () {
      return c(!0);
    }) : i === "always" ? c(!1) : i === "idle" && ("requestIdleCallback" in window ? requestIdleCallback : setTimeout)(function () {
      return c(!1);
    });
  }, [n.hidden, t, i]), s.createElement("div", _objectSpread({}, n), u ? e : null);
}

import * as l from "react";

function d(e) {
  var t = l.useRef();
  return l.useEffect(function () {
    t.current = e;
  }), t.current;
}

function f(e, t) {
  var i = l.useState(),
      _i = _slicedToArray(i, 2),
      n = _i[0],
      u = _i[1],
      c = l.useMemo(function () {
    return n ? e.indexOf(n) : -1;
  }, [n, e]),
      r = d(c);

  return l.useEffect(function () {
    if (e.length === 0) {
      u(void 0);
      return;
    }

    if (!(n === null || n && e.includes(n))) {
      if (typeof r == "number" && r >= 0 && (e[r] || e[r - 1])) {
        u(e[r] || e[r - 1]);
        return;
      }

      t !== null && u(t && e.includes(t) ? t : e[0]);
    }
  }, [t, r, n, u, e]), i;
}

export { o as TabPanel, f as useTabs };